/**
=========================================================
* Material Kit 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 PRO React base styles
import colors from "../../base/colors";

// Material Kit 2 PRO React helper functions
import pxToRem from "../../functions/pxToRem";
import boxShadow from "../../functions/boxShadow";
import { green } from "@mui/material/colors";

const { white } = colors;

export default {
  styleOverrides: {
    root: {
      // background: "#000000",
      background: "#9fc9ff",
      fill: colors.grey[500],
      stroke: colors.grey[500],
      strokeWidth: pxToRem(9),
      width: pxToRem(16),
      height: pxToRem(16),
      borderRadius: "50%",
      zIndex: 99,
      transition: "all 200ms linear",

      "&.Mui-active": {
        background: white.main,
        fill: white.main,
        stroke: white.main,
        borderColor: colors.JTCElectricBlue,
        boxShadow: boxShadow([0, 0], [2, 2], colors.info.main, 1),
      },

      "&.Mui-completed": {
        background: colors.success.main,
        fill: colors.JTCElectricBlue,
        stroke: colors.JTCElectricBlue,
        borderColor: colors.success.main,
        boxShadow: boxShadow([0, 0], [0, 0], white.main, 1),
    
        
      },
      "&.completed": {
        background: colors.JTCElectricBlue,
        fill: colors.JTCElectricBlue,
        stroke: colors.JTCElectricBlue,
        borderColor: colors.JTCElectricBlue,
      },
      "&.active": {
        background: colors.JTCElectricBlue,
        fill: colors.JTCElectricBlue,
        stroke: colors.JTCElectricBlue,
        borderColor: colors.JTCElectricBlue,
      },
    
    },
  },
};
